import * as tslib_1 from "tslib";
import styled from 'styled-components';
import { withProps } from '../styles';
/**
 * 获取文本颜色
 *
 * @param {LabelProps} props Label组件的属性对象
 *
 * @param {string} 返回文本颜色值
 */
export function getTextColor(props) {
    if (props.warning) {
        return props.theme.palette.warning[500];
    }
    else if (props.error) {
        return props.theme.palette.error[500];
    }
    else if (props.focused && !props.readOnly) {
        return props.theme.palette.primary[500];
    }
    else if (props.disabled) {
        return props.theme.palette.text.disabled;
    }
    return props.theme.typography.subheading.color;
}
/**
 * html标签组件
 *
 * @ReactComponent
 */
var Label = withProps()(styled.label)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: ", "rem;\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin: 0;\n  padding: 0;\n  ", ";\n"], ["\n  font-size: ", "rem;\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin: 0;\n  padding: 0;\n  ",
    ";\n"])), function (props) { return props.theme.typography.subheading.fontSize; }, function (props) { return props.theme.typography.fontFamily; }, function (props) { return props.theme.typography.subheading.fontWeight; }, function (props) { return getTextColor(props); }, function (props) {
    return props.required &&
        "\n    $:after {\n      content: '*';\n      padding: 4px;\n    }\n  ";
});
export default Label;
var templateObject_1;
//# sourceMappingURL=Label.js.map